





































import { computed, defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import AppContentCardThumbnail from '~/components/partials/App/AppContentCardThumbnail.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppSeeMoreButton from '~/components/partials/App/AppSeeMoreButton.vue';
import { useSilverEggApi } from '~/composables/silverEgg/useSilverEggApi';
import { useMatchMedia } from '~/composables/useMatchMedia';
import { DISPLAY_NUM } from '~/constants/silverEgg';
import { RecommendItem } from '~/types/common/silverEgg';

export default defineComponent({
  components: {
    AppContentCardThumbnail,
    AppLink,
    AppSeeMoreButton,
    AppImage,
  },
  props: {
    articles: {
      type: Array as PropType<RecommendItem[]>,
      default: () => [],
    },
    rqid: {
      type: String,
      default: '',
    },
    spec: {
      type: String,
      default: '',
    },
    isRanking: {
      type: Boolean,
      default: false,
    },
    rankingImgs: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    pagination: {
      type: Number,
      default: 1,
    },
  },
  setup(props, { emit }) {
    const { isMobile } = useMatchMedia();
    const { clickNotify } = useSilverEggApi();
    const page = ref(props.pagination);
    const isButtonVisible = computed(() => displayedArticles.value.length !== props.articles.length);
    const displayedArticles = computed(() =>
      props.articles.slice(
        0,
        isMobile.value ? page.value * DISPLAY_NUM.ARTICLES_SP : page.value * DISPLAY_NUM.ARTICLES_PC
      )
    );

    const convertCategories = (categories: string | undefined) => {
      return categories?.split(',') || [];
    };

    const sendClickRequest = async (articleId: string) => {
      await clickNotify({
        itemId: articleId,
        spec: props.spec,
        rqid: props.rqid,
      });
    };

    const clickSeeMoreButton = () => {
      page.value += props.isRanking ? 2 : 1; // 記事ランキングの場合は残りの分を全量表示
      emit('set-pagination', page.value);
    };

    return {
      convertCategories,
      page,
      isButtonVisible,
      displayedArticles,
      sendClickRequest,
      clickSeeMoreButton,
    };
  },
});
